import { useState, useEffect } from 'react';

/**
 * 响应式断点配置
 * 与 Ant Design 保持一致
 */
const breakpoints = {
  xs: 480,   // 超小屏幕 (手机竖屏)
  sm: 576,   // 小屏幕 (手机横屏)
  md: 768,   // 中等屏幕 (平板)
  lg: 992,   // 大屏幕 (小型桌面)
  xl: 1200,  // 超大屏幕 (桌面)
  xxl: 1600, // 超超大屏幕 (大型桌面)
};

/**
 * 响应式Hook - 用于检测当前屏幕尺寸
 * @returns {Object} 包含各种屏幕尺寸判断的对象
 */
const useResponsive = () => {
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1200,
    height: typeof window !== 'undefined' ? window.innerHeight : 800,
  });

  useEffect(() => {
    // 防抖处理
    let timeoutId = null;
    
    const handleResize = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }, 100);
    };

    window.addEventListener('resize', handleResize);
    
    // 初始化时也触发一次
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);

  const { width } = windowSize;

  return {
    // 窗口尺寸
    windowSize,
    
    // 是否为移动端 (小于768px)
    isMobile: width < breakpoints.md,
    
    // 是否为平板 (768px - 992px)
    isTablet: width >= breakpoints.md && width < breakpoints.lg,
    
    // 是否为桌面端 (大于等于992px)
    isDesktop: width >= breakpoints.lg,
    
    // 是否为超小屏幕 (小于480px)
    isXs: width < breakpoints.xs,
    
    // 是否为小屏幕 (小于576px)
    isSm: width < breakpoints.sm,
    
    // 是否为中等屏幕 (小于768px)
    isMd: width < breakpoints.md,
    
    // 是否为大屏幕 (小于992px)
    isLg: width < breakpoints.lg,
    
    // 是否为超大屏幕 (小于1200px)
    isXl: width < breakpoints.xl,
    
    // 断点值
    breakpoints,
    
    // 当前屏幕宽度
    screenWidth: width,
  };
};

export default useResponsive;







